import { gql } from "@apollo/client";

export const GET_USER_CARDS = gql`
  query GetUserCards($userId: uuid!) {
    physical_cards(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
    ) {
      id
      card_name
      cardholder_name
      card_number_last_four
      status
      current_balance
      available_balance
      spending_limit
      expiry_month
      expiry_year
      created_at
    }
    virtual_cards(
      where: { user_id: { _eq: $userId } }
      order_by: { created_at: desc }
    ) {
      id
      card_name
      card_type
      card_number_last_four
      status
      current_balance
      spending_limit
      expiry_date
      created_at
    }
  }
`;

export const DECRYPT_CARD_NUMBER = gql`
  mutation DecryptCardNumber($input: DecryptCardInput!) {
    decryptCardNumber(input: $input) {
      success
      cardNumber
      vvc
      message
    }
  }
`;

export const ACTIVATE_VIRTUAL_CARD = gql`
  mutation ActivateVirtualCard($input: CardActionInput!) {
    activateVirtualCard(input: $input) {
      success
      data {
        status
      }
      message
      error {
        message
      }
    }
  }
`;

export const SUSPEND_VIRTUAL_CARD = gql`
  mutation SuspendVirtualCard($input: CardActionInput!) {
    suspendVirtualCard(input: $input) {
      success
      data {
        status
      }
      message
      error {
        message
      }
    }
  }
`;

export const UPDATE_CARD_STATUS = gql`
  mutation UpdateCardStatus($input: UpdateCardStatusInput!) {
    updateCardStatus(input: $input) {
      success
      message
      error
    }
  }
`;

export const CHANGE_CARD_PIN = gql`
  mutation ChangeCardPin($input: ChangeCardPinInput!) {
    changeCardPin(input: $input) {
      success
      message
      pinSetDate
      error
    }
  }
`;
